import { NgModule } from 'ng-metadata/core';
import { DropModule } from './drop/drop.module';
import { FormsModule } from './forms/forms.module';
import { SearchModule } from './search/search.module';
import { RotatorModule } from './rotator/rotator.module';
import { SummaryModule } from './summary/summary.module';
import { CurrencyModule } from './currency/currency.module';
import { DirectoryModule } from './directory/directory.module';
import { OrderSummaryModule } from './order-summary/order-summary.module';
import { CheckoutTimerModule } from './checkout-timer/checkout-timer.module';
import { FacilitiesMapModule } from './facilities-map/facilities-map.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { ProductOptionsModule } from './product-options/product-options.module';
import { PassportSelectModule } from './passport-select/passport-select.module';
import { PassportDepartureDateModule } from './departure-date/departure-date.module';
import { PassportTypeDropModule } from './passport-type-drop/passport-type-drop.module';
import { MenuBarModule } from './menu-bar/menu-bar.module';

@NgModule({
  imports: [
    DropModule,
    FormsModule,
    SearchModule,
    MenuBarModule,
    RotatorModule,
    SummaryModule,
    CurrencyModule,
    DirectoryModule,
    OrderSummaryModule,
    CheckoutTimerModule,
    FacilitiesMapModule,
    AuthenticationModule,
    PassportSelectModule,
    ProductOptionsModule,
    PassportTypeDropModule,
    PassportDepartureDateModule,
  ],
})
export class CommonModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/common.module.ts